import React from 'react'
import './cta.scss'

const Cta = () => {
  return (
    <div>Cta</div>
  )
}

export default Cta